<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0" height="100%">
      <v-col cols="12">
        <v-card height="85vh" class="d-flex align-center justify-center">
          <v-sheet width="65%">
            <v-card-title class="justify-center">
              <div class="text-h5">Hi {{ userProfile.firstName }}!</div>
            </v-card-title>
            <v-card-subtitle class="text-center">
              Are you ready to provide your event attendees a platform to <br />
              connect with each other seamlessly? <br />
              Select a path to begin.
            </v-card-subtitle>
            <v-card-text class="d-flex justify-space-around align-center mt-8">
              <v-card
                v-for="path in paths"
                :key="path.id"
                height="200"
                width="205"
                color="#F2F8FF"
                class="d-flex justify-center align-center"
                @click="$router.push(path.route)"
              >
                <v-card-text
                  class="d-flex justify-center align-center flex-column"
                >
                  <v-icon color="secondary" size="80">
                    {{ path.icon }}
                  </v-icon>
                  <span class="text-center text-body">
                    {{ path.text }}
                  </span>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["userProfile"]),
  },
  data() {
    return {
      paths: [
        {
          id: "1",
          icon: "mdi-calendar-month",
          text: "How EventConnect works when organising an event or meeting",
          route: "/explainMultiConnect",
        },
        {
          id: "2",
          icon: "mdi-account-supervisor-outline",
          text: "How EventConnect works for your event attendees",
          route: "/explainMultiConnect",
        },
        {
          id: "3",
          icon: "mdi-link-variant-plus",
          text: "Create your first EventConnect link",
          route: "/explainMultiConnect",
        },
      ],
    };
  },
};
</script>
